import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import {newPresentacionSchema } from '@/shared';
import { useCreatePresentacion, useUpdatePresentacion } from '@/shared/actions/erp';
import {
  SingleFormBoxScene,
  SampleCheckbox,
  CustomTextField,
} from '@/shared/components/ui';
import { Presentacion } from '@/shared/interfaces';

const returnUrlPresentacion = '/inventario/presentacion';

export interface SavePresentacionInterface {
  titlePage: string;
  editPresentacion?: Presentacion;
}

type SaveFormData = {
  nombre: string;
  estado: boolean;
  descripcion: string;
};

const SavePresentacion: React.FC<SavePresentacionInterface> = ({ titlePage, editPresentacion }) => {
  

    const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);
  ///* mutations
  const createPresentacionMutation = useCreatePresentacion({navigate, returnUrl:returnUrlPresentacion});
  const updatePresentacionMutation = useUpdatePresentacion({navigate, returnUrl:returnUrlPresentacion});

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newPresentacionSchema),
    defaultValues:{
      estado: false,
    }
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editPresentacion?.id_presentacion) {
      return updatePresentacionMutation.mutate({
        id: editPresentacion.id_presentacion,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createPresentacionMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editPresentacion) {
      setShrink(true);
      reset({
        ...editPresentacion
      } as any);
    }
  }, [editPresentacion]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlPresentacion);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
              name="nombre"
              label="Nombre"
              control={form.control}
              defaultValue={form.getValues().nombre || ""}
              error={errors.nombre}
              helperText={errors.nombre?.message}
              shrink={shrink}
            />
                  <CustomTextField
              name="descripcion"
              label="Descripción"
              control={form.control}
              defaultValue={form.getValues().descripcion || ""}
              error={errors.descripcion}
              helperText={errors.descripcion?.message}
              shrink={shrink}
            />
   <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SavePresentacion;
